<template>
    <!--订单发货弹框（部分发货） -->
    <c-dialog ref="orderSendDialog" :title="title" width="900" button-name="确认发货" @resolve="orderSendHandle">
        <div style="background: #FAFAFA;">
            <c-form ref="orderSendForm" column="2">
                <c-form-item label="物流公司">
                    <c-select  name="logistics_company_id" :options="logisticsCompany"></c-select>
                </c-form-item>
                <c-form-item label="运单号">
                    <c-input name="logistics_number"></c-input>
                </c-form-item>
            </c-form>
        </div>
        <c-table ref="orderUnSendSKUList" height="320" :paging="false">
            <c-table-column type="selector" :selected="() => true"></c-table-column>

            <c-table-column
                    label="商品信息"
                    width="300"
            >
                <template v-slot="{data}">
                    <product-info v-if="data.product_itemnumber" :image="data.product_img_url"
                                  :name="data.product_itemnumber + ' - '+data.product_name"
                                  image-size="60"></product-info>
                    <product-info v-else :image="data.product_img_url" :name="data.product_name"
                                  image-size="60"></product-info>
                </template>
            </c-table-column>

            <c-table-column
                    label="商品信息"
                    name="product_sku_spec"
            ></c-table-column>

            <c-table-column
                    label="SKU编码"
                    name="product_sku_code"
            ></c-table-column>

            <c-table-column
                    label="未发数量"
            >
                <template v-slot="{data}">
                    ×{{ data.product_quantity }}
                </template>
            </c-table-column>

            <c-table-column
                    label="发货数量"
                    width="150"
            >
                <template v-slot="{data, selected}">
                    <c-input v-model="sendNum[data.product_sku]" type="number" width="100" :limit="[1, data.product_quantity]" :disabled="!selected" style="width:130px;" unit="件"></c-input>
                </template>
            </c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
    import productInfo from "@/components/public/product_info.vue";

    export default {
        components: {productInfo},
        props: {
        },
        mounted() {
            this.initLogisticsCompany();
        },
        data() {
            return {
                order_number:'',
                title:'订单发货',
                logisticsCompany:[], //发货物流公司
                sendNum: {}          //发货SKU对象
            }
        },
        methods: {
            //初始化发货物流公司
            initLogisticsCompany(){
                if (!this.logisticsCompany.length) {
                    this.request({
                        url: '/standard_logistics/all',
                        success: data => {
                            this.logisticsCompany = Array.from(data, item => {
                                return {
                                    name: item.logistics_name,
                                    value: item.id
                                };
                            });
                        }
                    });
                }
            },
            //打开发货弹窗
            open(order_number) {
                this.order_number = order_number;
                this.title = '订单【'+this.order_number+'】商品发货'
                //加载待发货商品列表
                this.request({
                    url: '/order/undelivered/product/list',
                    data: {
                        order_number: this.order_number
                    },
                    loading: true,
                    success: data => {
                        //赋值默认发货数量
                        data.sku_list.forEach(item => {
                            this.sendNum[item.product_sku] = item.product_quantity;
                        });
                        this.$refs.orderUnSendSKUList.setData(data.sku_list)
                        this.$refs.orderSendForm.clear();
                        this.$refs.orderSendForm.set({
                            logistics_company_id: data.logistics_company_id||0
                        });
                        this.$refs.orderSendDialog.open();
                    }
                });
            },
            //订单发货（部分发货）
            orderSendHandle(stop) {
                stop();
                let form = this.$refs.orderSendForm.get(),
                        list = this.$refs.orderUnSendSKUList.getRow('selected');
                new Promise(resolve => {
                    if (!form.logistics_company_id) {
                        resolve('请选择物流公司');
                    }

                    if (!form.logistics_number && form.logistics_company_id > 0) {
                        resolve('请填写运单号');
                    }

                    if (!list.length) {
                        resolve('请勾选需要执行发货的订单商品');
                    }

                    if (list.find(item => {
                        return (parseInt(this.sendNum[item.data.product_sku]) || 0) <= 0;
                    })) {
                        resolve('请填写已勾选发货商品的发货数量');
                    }

                    resolve(false);
                }).then(error => {
                    if (error) {
                        this.$message({
                            message: error
                        });
                        return;
                    }

                    this.request({
                        url: '/order/deliver',
                        data: Object.assign(form, {
                            order_number: this.order_number,
                            send_products: Array.from(list, item => {
                                return {
                                    product_sku: item.data.product_sku,
                                    product_count: parseInt(this.sendNum[item.data.product_sku])
                                }
                            })
                        }),
                        loading: true,
                        success: data => {
                            this.$refs.orderSendDialog.close();
                            this.$message({
                                text: '订单发货成功，结果可能稍有延时，如果发货状态未更新，请自行刷新页面'
                            });
                            setTimeout(()=>{
                                //调用响应方法
                                this.$emit('resolve',this.order_number);
                            },500);
                        }
                    });
                });
            },

            //修改收货地址（提交数据）
            receivingSubmitForm(stop){
                stop();
                this.$refs.receivingForm.submit({
                    url: '/order/edit_receiving_address',
                    rule: {
                        receiving_name: '请填写收货人',
                        receiving_phone: '请填写电话',
                        receiving_address_province_id: '请选择收货地址省份',
                        receiving_address_city_id: '请选择收货地址城市',
                        receiving_address_county_id: '请选择收货地址区县',
                        receiving_address_details: '请填写收货地址详情'
                    },
                    dataFormatter: data => {
                        return data;
                    },
                    success: (data, res) => {
                        this.$message({
                            text: '修改收货信息成功！'
                        });
                        this.$refs.receivingDia.close();
                        this.$emit('resolve',this.order_number);
                    }
                });
            },
        }
    }
</script>